import React, { useEffect } from 'react';

export default function AdBanner({ type = 'banner' }) {
  
  useEffect(() => {
    try {
      if (window.adsbygoogle) {
        // מנסה לטעון מודעה חדשה רק אם אין כבר אחת בתוך האלמנט הזה
        // (מונע כפילויות ושגיאות בקונסול)
        const ads = document.getElementsByClassName("adsbygoogle");
        if (ads.length > 0) {
             (window.adsbygoogle = window.adsbygoogle || []).push({});
        }
      }
    } catch (e) {
      console.error("AdSense Error:", e);
    }
  }, []);

  // קביעת גובה קשיח: באנר רגיל = 90 פיקסל, מרובע = 250 פיקסל
  const fixedHeight = type === 'banner' ? '90px' : '250px';

return (


  <div className="w-full flex justify-center my-8 bg-gray-50 overflow-hidden relative z-0" 
       style={{ minHeight: fixedHeight, paddingBottom: '10px' }}>
    {/* הוספת z-0 מבטיחה שהמודעה תמיד תהיה "מתחת" לכפתורי התפריט שלך */}
    <ins className="adsbygoogle"
         style={{ 
             display: 'inline-block', 
             width: '100%', 
             height: fixedHeight,
             maxHeight: fixedHeight
         }}
         data-ad-client="ca-pub-2270540361495416"
         data-ad-slot="1911201597"
         data-ad-format="horizontal"   
         data-full-width-responsive="false">
    </ins>
  </div>
);
}